import React, { Component } from "react";
import "./css/NavRow.css";
import Button from "@mui/material/Button";
import RestartAltIcon from "@mui/icons-material/RestartAlt";

class Navrow extends Component {
  saveDataNext = (event) => {
    //Go next
    //Which step are we on?
    //if im on step ==  OptionSelectView
    //call storeOptionsDataToMain
  };

  restartApp =(event) =>{

    window.location.reload();
  }

  render() {
    const { showNextButton, showPrevButton } =
      this.props;

    return (
      <div className="navrow">
        {this.props.refresh && (
          <Button
            onClick={this.restartApp}
            >
            {"Restart App"}
            <RestartAltIcon />
          </Button>
        )}
        { ((this.props.showPrevButton && (this.props.step !== 8 )) || this.props.step === 0) && 
        <Button
          style={{ fontFamily: "Ford-Normal" }}
          disabled={!showPrevButton}
          onClick={this.props.previous}
          variant="outlined"
        >
          Previous
        </Button>}

        <Button
          style={{ fontFamily: "Ford-Normal" }}
          className="navbtn"
          onClick={this.props.next}
          variant="contained"
          color={this.props.submit ? "success" : "primary"}
          disabled={!showNextButton}
        >
          {this.props.submit ? "Submit" : "Next"}
        </Button>
      </div>
    );
  }
}

export default Navrow;
